import { type RouteRecordRaw } from 'vue-router'

export const deliveryRouter: RouteRecordRaw[] = [
  {
    component: async () => import('../views/DeliveryMainView.vue'),
    meta: {
      title: 'restaurant.delivery',
    },
    name: 'brand.delivery',
    path: 'delivery',
  },
]
